import React from 'react';
import { Container, Row } from 'react-bootstrap';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { createImageViewerButton, createImageViewer } from '../../helpers/imageViewerHelpers';
import { createStyledImageListItemBar } from '../../helpers';
import modelSheet from '../../Assets/CharacterDesign/marios/modelSheet.jpg';
import modelSheetNoLines from '../../Assets/CharacterDesign/marios/modelSheetNoLines.jpg';
import posesAndExpressions from '../../Assets/CharacterDesign/marios/posesAndExpressions.jpg';
import mikroula from '../../Assets/CharacterDesign/mikroula/mikroulaModelSheet.jpg';
import dadSketches from '../../Assets/CharacterDesign/storyteller/dadSketches.jpg';
import modelSheetDad from '../../Assets/CharacterDesign/storyteller/modelSheetDad.jpg';
import modelSheetDadNoLines from '../../Assets/CharacterDesign/storyteller/modelSheetDadNoLines.jpg';
import modelSheetTeddy from '../../Assets/CharacterDesign/teddy/modelSheetTeddy.jpg';
import modelSheetTeddyNoLines from '../../Assets/CharacterDesign/teddy/modelSheetTeddyNoLines.jpg';
import verveloArmchair from '../../Assets/CharacterDesign/vervelo/armchairModel.jpg';
import verveloArmchairWithLines from '../../Assets/CharacterDesign/vervelo/modelSheetWithLines.jpg';


const mariosCharacterDesignData = [
  {
    img: modelSheet,
    title: 'Character Model Sheet - Mario',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: modelSheetNoLines,
    title: 'Character Model Sheet No Lines - Mario',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: posesAndExpressions,
    title: 'Character Poses and Expressions - Mario',
    author: 'Nikoletta Papakonstantinou',
  },
];

const mikroulaCharacterDesignData = [
  {
    img: mikroula,
    title: 'Character Model Sheet - Mikroula',
    author: 'Nikoletta Papakonstantinou',
  },
];

const storytellerCharacterDesignData = [
  {
    img: dadSketches,
    title: 'Character Sketches - Storyteller Dad',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: modelSheetDad,
    title: 'Character Model Sheet - Storyteller Dad',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: modelSheetDadNoLines,
    title: 'Character Model Sheet No Lines - Storyteller Dad',
    author: 'Nikoletta Papakonstantinou',
  },
];

const teddyCharacterDesignData = [
  {
    img: modelSheetTeddy,
    title: 'Character Model Sheet - Teddy',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: modelSheetTeddyNoLines,
    title: 'Character Model Sheet No Lines - Teddy',
    author: 'Nikoletta Papakonstantinou',
  },
];

const verveloCharacterDesignData = [
  {
    img: verveloArmchair,
    title: 'Character Model Sheet - Vervelo Armchair',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: verveloArmchairWithLines,
    title: 'Character Model Sheet With Lines - Vervelo Armchair',
    author: 'Nikoletta Papakonstantinou',
  },
];

function CharacterDesign() {
  // Image viewer state
  const [currentMariosImage, setCurrentMariosImage] = React.useState(0);
  const [isMariosViewerOpen, setIsMariosViewerOpen] = React.useState(false);
  const [currentMikroulaImage, setCurrentMikroulaImage] = React.useState(0);
  const [isMikroulaViewerOpen, setIsMikroulaViewerOpen] = React.useState(false);
  const [currentStorytellerImage, setCurrentStorytellerImage] = React.useState(0);
  const [isStorytellerViewerOpen, setIsStorytellerViewerOpen] = React.useState(false);
  const [currentTeddyImage, setCurrentTeddyImage] = React.useState(0);
  const [isTeddyViewerOpen, setIsTeddyViewerOpen] = React.useState(false);
  const [currentVerveloImage, setCurrentVerveloImage] = React.useState(0);
  const [isVerveloViewerOpen, setIsVerveloViewerOpen] = React.useState(false);

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Character Design</strong>
        </h1>
      </Container>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Marios</strong>
        </h1>
        <p style={{ color: 'black' }}>
          <strong>Commission work</strong> Meet Marios — a bright-eyed, five-year-old bursting with imagination!
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {mariosCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentMariosImage(index);
                setIsMariosViewerOpen(true);
              },
              characterType: 'Marios Character Design'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Mikroula</strong>
        </h1>
        <p style={{ color: 'black' }}>
          <strong>Personal Project</strong> - A tiny chef with a huge heart fighting with her own fears and sizzling insecurities every time she cooks- making a glorious mess along the way!
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {mikroulaCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentMikroulaImage(index);
                setIsMikroulaViewerOpen(true);
              },
              characterType: 'Mikroula Character Design'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Storyteller</strong>
        </h1>
        <p style={{ color: 'black' }}>
          <strong>Commission work</strong> - A carrying dad who comes up with outstanding concepts and uniques stories in order to lull his son to sleep.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {storytellerCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentStorytellerImage(index);
                setIsStorytellerViewerOpen(true);
              },
              characterType: 'Storyteller Character Design'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Teddy</strong>
        </h1>
        <p style={{ color: 'black' }}>
          <strong>Part of a school assignment</strong> - A loyal guide who helps a lost teen rediscover their worth and learn to speak up for themselves.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {teddyCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentTeddyImage(index);
                setIsTeddyViewerOpen(true);
              },
              characterType: 'Teddy Character Design'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Vervelo</strong>
        </h1>
        <p style={{ color: 'black' }}>
          <strong>Vervelo has a dull job</strong> and a quiet love for his wife. Worn down by routine, he grew absurdly long arms—just long enough to grab anything he needs without leaving his armchair. Life hasn’t broken him, just stretched him thin.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {verveloCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentVerveloImage(index);
                setIsVerveloViewerOpen(true);
              },
              characterType: 'Vervelo Character Design'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>

      {/* All Image Viewers at the top level for full-screen display */}
      {createImageViewer({
        isOpen: isMariosViewerOpen,
        images: mariosCharacterDesignData.map(item => item.img),
        currentIndex: currentMariosImage,
        onClose: () => setIsMariosViewerOpen(false),
      })}

      {createImageViewer({
        isOpen: isMikroulaViewerOpen,
        images: mikroulaCharacterDesignData.map(item => item.img),
        currentIndex: currentMikroulaImage,
        onClose: () => setIsMikroulaViewerOpen(false),
      })}

      {createImageViewer({
        isOpen: isStorytellerViewerOpen,
        images: storytellerCharacterDesignData.map(item => item.img),
        currentIndex: currentStorytellerImage,
        onClose: () => setIsStorytellerViewerOpen(false),
      })}

      {createImageViewer({
        isOpen: isTeddyViewerOpen,
        images: teddyCharacterDesignData.map(item => item.img),
        currentIndex: currentTeddyImage,
        onClose: () => setIsTeddyViewerOpen(false),
      })}

      {createImageViewer({
        isOpen: isVerveloViewerOpen,
        images: verveloCharacterDesignData.map(item => item.img),
        currentIndex: currentVerveloImage,
        onClose: () => setIsVerveloViewerOpen(false),
      })}
    </Container>
  );
}

export default CharacterDesign;
